import React from "react";

const Footer = () => {
  const date = new Date();
  const year = date.getFullYear();
  return (
    <footer className="bottom-fixed">
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <p className="text_mob_center">COPYRIGHT &#169; {year}</p>
          </div>
          <div className="col-md-6 privacy">
            <a
              href="https://www.solebs.com/privacy-policy"
              target="_blank"
              rel="noreferrer"
            >
              Privacy Policy
            </a>{" "}
            <span className="me-1 ms-1"> | </span>{" "}
            <a
              href="https://www.solebs.com/terms-conditions"
              target="_blank"
              rel="noreferrer"
            >
              Terms & Conditions
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
